import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ThermometerSun } from 'lucide-react';

const Fleet = () => {
  return (
    <section className="bg-gray-50 py-16 sm:py-24 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-2 mb-4">
              <Zap className="text-green-500" size={24} />
              <span className="text-green-600 font-medium">100% Électrique</span>
            </div>
            <h2 
              className="text-2xl sm:text-3xl md:text-4xl text-gray-900 mb-4 sm:mb-6"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Dongfeng Nammi 01
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6 text-sm sm:text-base">
              Notre véhicule électrique moderne et confortable pour tous vos déplacements au Sénégal. 
              Climatisation performante, intérieur spacieux et conduite silencieuse pour un trajet agréable.
            </p>
            <div className="flex flex-wrap gap-3 sm:gap-4 mb-6 sm:mb-8 justify-center lg:justify-start">
              <div className="flex items-center gap-2 bg-green-50 px-3 sm:px-4 py-2 rounded-full transition-transform hover:scale-105">
                <Zap size={16} className="text-green-500" />
                <span className="text-xs sm:text-sm text-green-700">Électrique</span>
              </div>
              <div className="flex items-center gap-2 bg-blue-50 px-3 sm:px-4 py-2 rounded-full transition-transform hover:scale-105">
                <ThermometerSun size={16} className="text-blue-500" />
                <span className="text-xs sm:text-sm text-blue-700">Climatisée</span>
              </div>
            </div>
            <Link
              to="/fleet"
              className="inline-block px-6 sm:px-8 py-3 bg-gray-900 text-white text-sm hover:bg-gray-800 transition-all duration-300 rounded-full hover:scale-105 hover:shadow-lg"
            >
              Découvrir notre flotte
            </Link>
          </div>

          {/* Vehicle Images */}
          <div className="relative mt-8 lg:mt-0">
            <div className="overflow-hidden rounded-2xl shadow-2xl group">
              <img
                src="https://global-img.bitauto.com/usercenter/autoalbum/20250429/25/w1200_yichecar_591976302520652.png.webp"
                alt="Dongfeng Nammi 01"
                className="w-full h-64 sm:h-80 object-cover transition-transform duration-700 group-hover:scale-110"
              />
            </div>
            <div className="hidden sm:block absolute -bottom-6 -left-6 bg-white p-3 sm:p-4 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2">
              <img
                src="https://global-img.bitauto.com/usercenter/autoalbum/20250409/506/w1200_yichecar_418880650657521.jpg.webp"
                alt="Nammi 01 Intérieur"
                className="w-24 sm:w-32 h-20 sm:h-24 object-cover rounded-lg"
              />
            </div>
            <div className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 bg-green-500 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full shadow-lg font-medium text-xs sm:text-sm animate-pulse">
              ⚡ Écologique
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Fleet;
